import { useMemo } from 'react';
import { calculateProgressionData } from '../utils/metrics/progression.js';
import { calculateAscentTypeStats } from '../utils/metrics/ascentTypes.js';
import { calculateCragStats } from '../utils/metrics/cragStats.js';
import { CLIMBING_STYLES } from '../utils/constants.js';

export const useChartData = (filteredData, metric, climbingStyle) => {
  return useMemo(() => {
    switch (metric) {
      case 'progression': {
        return calculateProgressionData(
          filteredData,
          climbingStyle || CLIMBING_STYLES.SPORT
        );
      }

      case 'types': {
        return calculateAscentTypeStats(
          filteredData,
          climbingStyle || CLIMBING_STYLES.SPORT
        );
      }

      case 'crags': {
        // calculateCragStats returns { crags: [...], minCPG: number }
        const stats = calculateCragStats(
          filteredData,
          climbingStyle || CLIMBING_STYLES.SPORT
        );
        console.log('Crag stats calculated:', stats);
        return stats;  // This already returns the correct { crags: [...] } structure
      }

      case 'grades':
      case 'flash':
      case 'ascents':
      case 'routesPerYear':
      case 'projects':
      case 'cragPerformance':
      default:
        return {
          data: filteredData  // Wrap in an object if needed by other charts
        };
    }
  }, [filteredData, metric, climbingStyle]);
};